export function timeDifference(from, to) {
  const startH = from.$H;
  const startM = from.$m;
  const endH = to.$H;
  const endM = to.$m;

  let diffMinutes = endM - startM;
  let diffHours = endH - startH;
  if (diffMinutes < 0) {
    diffMinutes += 60;
    diffHours -= 1;
  }
  return {
    diffHours,
    diffMinutes,
  };
}
const formatDate = (date) => {
  return date
    .toLocaleDateString('en-US', {
      weekday: 'short',
      day: '2-digit',
      month: 'short',
      year: 'numeric',
    })
    .replace(/(\w{3}), (\w{3}) (\d{2}), (\d{4})/, '$1, $3-$2-$4');
};
export const timerCalculation = (taskList) => {
  const resultArray = [];
  // eslint-disable-next-line no-plusplus
  for (let i = 0; i < 2; i++) {
    // const checkDate = new Date(new Date() - new Date(i * 24 * 60 * 60 * 1000)).toDateString();
    const checkDate = formatDate(new Date(new Date() - i * 24 * 60 * 60 * 1000));

    let total = 0;
    const resultObj = {};
    const dailyTaskList = [];

    // eslint-disable-next-line no-restricted-syntax
    for (const task of taskList) {
      let taskTotalTime = 0;
      let resultTask = { ...task, TimeTracker: [] };
      // eslint-disable-next-line no-restricted-syntax
      for (const tracker of task.TimeTracker) {
        if (tracker.stopTime && formatDate(new Date(tracker.startTime)) === checkDate) {
          const stopTime = tracker?.stopTime;
          if (stopTime) total += new Date(stopTime).getTime() - new Date(tracker?.startTime).getTime();
          taskTotalTime += new Date(stopTime).getTime() - new Date(tracker?.startTime).getTime();
          resultTask = { ...task, TimeTracker: [...resultTask?.TimeTracker, tracker], taskTotalTime };
        }
      }
      if (resultTask?.TimeTracker.length) dailyTaskList.push(resultTask);
    }
    if (total !== 0) {
      resultObj.checkDate = checkDate;
      resultObj.totalTime = new Date(total - 5.5 * 60 * 60 * 1000);
      resultObj.tasks = dailyTaskList;

      resultArray.push(resultObj);
    }
  }
  return resultArray;
};

export const todayTimeCalculation = (taskList) => {
  let total = 0;
  // eslint-disable-next-line
  for (const task of taskList) {
    // eslint-disable-next-line
    for (const tracker of task.TimeTracker) {
      // Checking for same date
      if (new Date(tracker.startTime).toDateString() === new Date().toDateString()) {
        const stopTime = tracker?.stopTime;
        if (stopTime) total += new Date(stopTime).getTime() - new Date(tracker?.startTime).getTime();
      }
    }
  }
  return total;
};

export const addTimeIntervals = (todayTime, currentRunningTime) => {
  const timePeriod = todayTime.toTimeString().split(' ')[0];
  const parts = timePeriod.split(/:/);
  const timePeriodMillis =
    parseInt(parts[0], 10) * 60 * 60 * 1000 + parseInt(parts[1], 10) * 60 * 1000 + parseInt(parts[2], 10) * 1000;
  const newDate = new Date();
  newDate.setTime(currentRunningTime.getTime() + timePeriodMillis);
  return newDate;
};

export const convertHM = (totalSeconds) => {
  if (totalSeconds) {
    if (totalSeconds < 60) return `${totalSeconds}s`;
    const hours = parseInt(parseInt(totalSeconds, 10) / (60 * 60), 10);
    const minutes = parseInt((parseInt(totalSeconds, 10) - hours * 60 * 60) / 60, 10);
    return `${hours}h ${minutes}m`;
  }
  return 0;
};

export const formatHours = (totalHours) => {
  if (totalHours) {
    const hours = Math.floor(totalHours); // Whole hours
    const minutes = Math.round((totalHours - hours) * 60); // Remaining minutes
    return `${hours}h ${minutes}m`;
  }
  return '0h 0m';
};
export const secondsToTime = (duration) => {
  const seconds = Math.floor(duration % 60)
    .toString()
    .padStart(2, '0');
  const minutes = Math.floor((duration / 60) % 60)
    .toString()
    .padStart(2, '0');
  const hours = Math.floor(duration / 60 / 60)
    .toString()
    .padStart(2, '0');
  return `${hours}:${minutes}:${seconds}`;
};
export const dateToTime = (dateString) => {
  const date = new Date(dateString);
  return `${date.getHours().toString().padStart(2, '0')}:${date.getMinutes().toString().padStart(2, '0')}:${date
    .getSeconds()
    .toString()
    .padStart(2, '0')}`;
};
export const dateToDDMMYYY = (dateString) => {
  const date = new Date(dateString);
  const year = String(date.getFullYear()).padStart(4, '0');
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const dt = String(date.getDate()).padStart(2, '0');
  return `${dt}-${month}-${year}`;
};

export const getTimeZone = () => {
  const offset = new Date().getTimezoneOffset();
  const o = Math.abs(offset);
  return `${(offset < 0 ? '+' : '-') + `00${Math.floor(o / 60)}`.slice(-2)}:${`00${o % 60}`.slice(-2)}`;
};
